import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import verificationApi from "../api/verification.api";
import { DocumentTypeDetail } from "../models/response/documentType";
import { DocumentUploadRequest } from "../models/request/documentUploadRequest";
import {
  DocumentUploadResponse,
  RetrieveUserDocumentResponse,
  RetrieveBankDetailResponse,
  RetrieveUserBankAccountResponse,
} from "../models/response";
import { UserDocumentInsertRequest } from "../models/request/userDocumentInsertRequest";
import { BankPersistRequest } from "../models/request/bankPersistRequest";
import errorModal from "../../../services/errorModal.service";

const verificationService = {
  getDocumentTypes: async (): Promise<UnifiedResponse<DocumentTypeDetail>> => {
    var response = await verificationApi.getDocumentTypes();
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response;
  },

  retrieveUserDocument: async (): Promise<
    UnifiedResponse<RetrieveUserDocumentResponse>
  > => {
    var response = await verificationApi.retrieveUserDocument();
    return response;
  },

  uploadFrontDocument: async (
    data: DocumentUploadRequest
  ): Promise<UnifiedResponse<DocumentUploadResponse>> => {
    var response = await verificationApi.uploadFrontDocument(data);
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response;
  },

  uploadBackDocument: async (
    data: DocumentUploadRequest
  ): Promise<UnifiedResponse<DocumentUploadResponse>> => {
    var response = await verificationApi.uploadBackDocument(data);
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response;
  },

  userDocumentInsert: async (
    data: UserDocumentInsertRequest
  ): Promise<UnifiedResponse<any>> => {
    var response = await verificationApi.userDocumentInsert(data);
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response;
  },

  retrieveBankAccounts: async (): Promise<
    UnifiedResponse<RetrieveUserBankAccountResponse>
  > => {
    var response = await verificationApi.retrieveBankAccounts();
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response;
  },

  retrieveBankDropdown: async (isActive: boolean): Promise<UnifiedResponse<any>> => {
    var response = await verificationApi.retrieveBankDropdown(isActive);
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response;
  },

  uploadBankDocument: async (data: DocumentUploadRequest): Promise<UnifiedResponse<any>> => {
    var response = await verificationApi.uploadBankDocument(data);
    return response;
  },

  persistBankAccount: async (data: BankPersistRequest): Promise<UnifiedResponse<any>> => {
    var response = await verificationApi.persistBankAccount(data);
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response;
  },


  deleteBankAccount: async (id: string): Promise<UnifiedResponse<RetrieveBankDetailResponse>> => {
    var response = await verificationApi.deleteBankAccount(id);
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response;
  },

};

export default verificationService;
